import React from 'react';
import PropTypes from 'prop-types';

// Лейбл (.ctl-label) + поле (.input) новой верстки. Переиспользуется на всех страницах.
export default function LabeledInput({ label, value, onChange, type, placeholder, disabled, className, step }) {
    return (
        <div className={className}>
            <label className="ctl-label">{label}</label>
            <input
                className="input"
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                step={step}
            />
        </div>
    );
}

LabeledInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    step: PropTypes.string
};

LabeledInput.defaultProps = {
    type: 'text',
    placeholder: undefined,
    disabled: false,
    className: undefined,
    step: undefined
};
